import translations from '../../components/TrustList/TrustList.translations'

export const deliveryItem = () => {
  return {
    id: 'reassurance_service_delivery',
    icon: 'IconSecured',
    i18n: {
      translation: translations.delivery,
    },
  }
}
